import { render, staticRenderFns } from "./TermPolicyCreate.vue?vue&type=template&id=2ec701ec&scoped=true"
import script from "./TermPolicyCreate.vue?vue&type=script&lang=js"
export * from "./TermPolicyCreate.vue?vue&type=script&lang=js"
import style0 from "./TermPolicyCreate.vue?vue&type=style&index=0&id=2ec701ec&prod&scoped=true&lang=css"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec701ec",
  null
  
)

export default component.exports